import Banner from '../banner/banner';
import Fotos from '../body/fotos';
import Rodape from '../rodape/rodape';
import "./Laurinda.css"

function Laurinda() {
  return (
    <div className='Laurinda'>
    <Banner />
    <Fotos/>
    <Rodape/>
    </div>
  );
}

export default Laurinda;
